import type { ModelWarehouseInventoryState } from '@app/api/WarehouseInventories';
import type { InventoryFilters } from '@app/pages/Warehouses/Inventory/types';

export const PF = 'inventory';

export const initialFilters: InventoryFilters = {
  Page: 1,
  ItemsPerPage: 20,
  SearchTerm: '',
};

export const statusTitles: Record<ModelWarehouseInventoryState, string> = {
  open: 'Открыта',
  done: 'Завершена',
};
